import { Component } from "@angular/core";


@Component({
    templateUrl: "./nurse-module.html"
})
export class NurseModulePage {
    
}